import * as PopupEditor from '@bingads-webui/popup-editor';
import { AdGroup } from '@bingads-webui-campaign/campaign-ui-schemas';
import { InlineEditableSave } from './save';


export function InlineEditableColumnPrompt({
  position, item, view, i18n, fieldName, saveModel = null, customValidators = null,
  adGroupSchema = AdGroup, customClass, customHint,
}) {
  let saveModelCallback;

  if (saveModel) {
    saveModelCallback = saveModel;
  } else {
    saveModelCallback = (updated, editorView) =>
      InlineEditableSave({
        view,
        i18n,
        fieldName,
        updated,
        editorView,
        editorViewCallbackAfterUpdate: () => editorView.trigger('save', updated),
      });
  }

  PopupEditor.prompt({
    position,
    i18n,
    schema: adGroupSchema,
    model: item,
    fields: [fieldName],
    hasLabels: false,
    template: 'inline',
    customValidators,
    saveModel: saveModelCallback,
    parentContainerSelector: '.grid-and-disclaim-container',
    customClass,
    customHint,
  });
}
